import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { StyledCarousel } from './StyledCarousel';

import { Breakpoints } from 'styles/Constants';

const defaultProps = {
  disableDotsControls: false,
  infinite: false,
  stagePadding: {
    paddingLeft: 10,
    paddingRight: 10
  }
};

export interface CarouselProps {
  startIndex: number;
  itemsForMobile?: number;
  itemsForTablet?: number;
  itemsForSmallLaptop?: number;
  itemsForLaptop?: number;
  itemsForWeb?: number;
  itemsForLarge?: number;
  itemsForExtraLarge?: number;
  items: Array<JSX.Element>;
  paddingRight?: number;
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({
  startIndex,
  items,
  itemsForMobile = 1,
  itemsForTablet = 2,
  itemsForSmallLaptop = 3,
  itemsForLaptop = 3.5,
  itemsForWeb = 3.5,
  itemsForLarge = 4,
  itemsForExtraLarge = 5,
  paddingRight,
  className
}) => {
  return (
    <StyledCarousel className={className}>
      <AliceCarousel
        mouseTracking
        items={items}
        activeIndex={startIndex}
        paddingRight={paddingRight}
        responsive={{
          0: { items: itemsForMobile },
          [Breakpoints.medium]: { items: itemsForTablet },
          [Breakpoints.xxmedium]: { items: itemsForSmallLaptop },
          [Breakpoints.cLarge]: { items: itemsForLaptop },
          [Breakpoints.large]: { items: itemsForWeb },
          [Breakpoints.xLarge]: { items: itemsForLarge },
          [Breakpoints.xxLarge]: { items: itemsForExtraLarge }
        }}
        {...defaultProps}
      />
    </StyledCarousel>
  );
};

export default Carousel;
